<template>
    <component :is="type" :class="[headlineClass[type]]"><slot/></component>
</template>

<script>
export default {
    name: "Headline",
    data() {
        return {
            headlineClass: {
                h1: 'text-xl sm:text-h1 text-secondary font-medium mb-4',
                h2: 'text-lg sm:text-xl text-secondary font-medium',
                h3: 'text-lg',
            }
        }
    },
    props: {
        type: {
            type: String,
            required: false,
            default: 'h2'
        }
    }
}
</script>

<style scoped>

</style>
